import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Col, Form, Row, DatePicker, Card } from 'antd';
import Input from '../../../ui/Input';
import ActionButtonsBar from '../../../ui/ActionButtonsBar';
import { LocalPersistence, ApiCallsFactory } from '../../../../factories';
import moment from 'moment';
import PageContainer from '../../../CSIComponents/PageContainer';
import Loading from '../../../Loading';
import { disableContent } from '../../../../helpers/misc/disableContent';

const dateFormat = 'MM/DD/YYYY';
const { RangePicker } = DatePicker;

declare global {
  interface Window {
    closuresAdd: boolean;
  }
}

const Edit = (props: any) => {
  const [editFlag, setEditFlag] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [name, setName] = useState<string>('');
  const [dateRange, setDateRange] = useState<null | any>(null);

  function validation() {
    const rangeText = /^(.){0,128}$/;
    if (rangeText.test(name) && dateRange !== null) {
      return (window.closuresAdd = true);
    }
    return (window.closuresAdd = false);
  }

  const watcher = async () => {
    const saveBtn: any = document.querySelectorAll('[data-test="save-btn"]');
    // save button functionality
    if (window.closuresAdd) {
      for (let i = 0; i < saveBtn.length; i++) {
        saveBtn[i]?.classList?.remove('is-disabled');
      }
    } else {
      for (let i = 0; i < saveBtn.length; i++) {
        saveBtn[i]?.classList?.add('is-disabled');
      }
    }
  };

  useEffect(() => {
    // adding listeners
    window.addEventListener('input', () => {
      watcher();
    });
    window.addEventListener('change', () => {
      watcher();
    });
    window.addEventListener('click', () => {
      watcher();
    });
    window.addEventListener('mousemove', () => {
      watcher();
    });
    setName(props.rowData.name);
    setDateRange([
      moment(props.rowData.startdate),
      moment(props.rowData.enddate),
    ]);
    // disabled the save button
    validation();
    if (props.isEditable) disableContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    validation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, dateRange]);

  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session');
      const session: any = await get_session.getSessionPersistence();
      const body = {
        supplier: session.supplier,
        propertyId: session.propertyId,
        property: {
          closures: [
            {
              closureid: props.rowData.closureid,
              closurelangid: props.rowData.closurelangid,
              name: value.name,
              startdate:
                (value.dateRange[0] &&
                  moment(value.dateRange[0]).format(dateFormat)) ||
                '',
              enddate:
                (value.dateRange[1] &&
                  moment(value.dateRange[1]).format(dateFormat)) ||
                '',
            },
          ],
        },
      };
      try {
        // post
        const basicInfoUpdated = new ApiCallsFactory(
          '/basicinformation/closures',
          session.token,
          body
        );
        await basicInfoUpdated.putData();
        setAddLoading(true);
        setAddLoading(false);
        form.resetFields();
        props.cancelAddAndEdit();
      } catch (error) {
        throw new Error('something went wrong');
      }
    });
  };

  const deleteField = async () => {
    const get_session = new LocalPersistence('session');
    const session: any = await get_session.getSessionPersistence();
    const body = {
      supplier: session.supplier,
      propertyId: session.propertyId,
      property: {
        closures: [
          {
            closureid: props.rowData.closureid,
            closurelangid: props.rowData.closurelangid,
          },
        ],
      },
    };
    try {
      // post
      const basicInfoUpdated = new ApiCallsFactory(
        '/basicinformation/closures',
        session.token,
        body
      );
      await basicInfoUpdated.deleteData();
      setAddLoading(true);
      setAddLoading(false);
      props.cancelAddAndEdit();
    } catch (error) {
      throw new Error('something went wrong');
    }
  };

  const editHandle = () => {
    setEditFlag(true);
    const initialValues = {
      name: props.rowData.name,
      dateRange: [
        moment(props.rowData.startdate),
        moment(props.rowData.enddate),
      ],
    };
    form.setFieldsValue(initialValues);
  };

  const cancelEdit = () => {
    setEditFlag(false);
    const initialValues = {
      name: props.rowData.name,
      type: props.rowData.type,
      detail: props.rowData.detail,
      quantity: parseInt(props.rowData.quantity),
    };
    form.setFieldsValue(initialValues);
  };

  const back = () => {
    props.cancelAddAndEdit();
    form.resetFields();
  };

  if (addLoading) return <Loading type="large" />;
  return editFlag ? (
    <PageContainer>
      <Card style={{ marginTop: 0 }}>
        <Grid
          container
          spacing={0}
          className="containerSpacing py-0"
        >
          <Grid
            item
            xs={12}
            className="p-0"
          >
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                {props.rowData.programname}
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            className="pb-0 px-0 my-0"
          >
            <Form
              layout="vertical"
              form={form}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Closure Name"
                    name="name"
                    rules={[
                      {
                        max: 128,
                        message:
                          'You have reached the max character length of 128',
                      },
                    ]}
                  >
                    <Input
                      maxLength={128}
                      edit={editFlag}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Start Date ~ End Date"
                    name="dateRange"
                    rules={[
                      { required: true, message: 'This field is required' },
                    ]}
                  >
                    <RangePicker
                      format={dateFormat}
                      onChange={(e) => setDateRange(e)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onDelete={deleteField}
        onCancel={cancelEdit}
        onSave={addSave}
      />
    </PageContainer>
  ) : (
    <PageContainer>
      <Card style={{ marginTop: 0 }}>
        <Grid
          container
          spacing={0}
          className="containerSpacing py-0"
        >
          <Grid
            item
            xs={12}
            className="p-0"
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                Closures
              </div>
              <div>
                <Button
                  style={{
                    background: '#004771',
                    color: '#fff',
                    width: 60,
                    height: 28,
                    margin: '0 10px 0 0',
                  }}
                  onClick={back}
                >
                  Back
                </Button>
                <Button
                  style={{
                    background: '#004771',
                    color: '#fff',
                    width: 60,
                    height: 28,
                  }}
                  onClick={() => {
                    editHandle();
                  }}
                >
                  Edit
                </Button>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            className="pb-0 px-0 my-0 is-disabled-fields"
          >
            <Form
              layout="vertical"
              form={form}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                name: props.rowData.name,
                dateRange: [
                  moment(props.rowData.startdate),
                  moment(props.rowData.enddate),
                ],
              }}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Closure Name"
                    name="name"
                    rules={[
                      {
                        max: 128,
                        message:
                          'You have reached the max character length of 128',
                      },
                    ]}
                  >
                    <Input onChange={(e) => setName(e.target.value)} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Start Date ~ End Date"
                    name="dateRange"
                    rules={[
                      { required: true, message: 'This field is required' },
                    ]}
                  >
                    <RangePicker
                      format={dateFormat}
                      onChange={(e) => setDateRange(e)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
    </PageContainer>
  );
};
export default Edit;
